/**
 * Login Page JavaScript
 * Extracted from land_price/templates/accounts/login.html
 */

// Import the canonical Public/Web foundation before auth composition.
import './public-design-system-standalone.js';

// Import shared auth styles (skip links, logo-link, etc.)
import './auth-common.css';

// Import CSS
import './login.css';

// Password Toggle Function
function togglePassword(fieldId) {
    const field = document.getElementById(fieldId);
    const toggleButton = field.nextElementSibling;

    if (field.type === 'password') {
        field.type = 'text';
        toggleButton.innerHTML = `
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
            </svg>
        `;
        toggleButton.setAttribute('aria-label', 'Ocultar senha');
    } else {
        field.type = 'password';
        toggleButton.innerHTML = `
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
        `;
        toggleButton.setAttribute('aria-label', 'Mostrar senha');
    }
}

// Make togglePassword available globally for onclick handlers
window.togglePassword = togglePassword;

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
    // Allow keyboard toggle (Enter/Space on password toggle button)
    const toggleButtons = document.querySelectorAll('.password-toggle');
    toggleButtons.forEach(button => {
        button.addEventListener('keypress', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                button.click();
            }
        });
    });

    // Button Loading States
    const loginForm = document.getElementById('login-form');
    if (loginForm) {
        const submitBtn = loginForm.querySelector('button[type="submit"]');

        loginForm.addEventListener('submit', function(e) {
            // Don't prevent default - allow form to submit
            // Just add loading state
            submitBtn.classList.add('btn-loading');
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-busy', 'true');

            // After 3 seconds, if still on page (validation failed), remove loading
            setTimeout(function() {
                submitBtn.classList.remove('btn-loading');
                submitBtn.disabled = false;
                submitBtn.setAttribute('aria-busy', 'false');
            }, 3000);
        });
    }
});

console.log('✅ Login page JavaScript loaded');
